export default "__VITE_ASSET__h7y0TVnW__"